import React, { useState, useEffect} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    Modal,
    ModalBody,
    ModalHeader,
    Button,
    ButtonToolbar,
    Row,
    Col,
} from "reactstrap";
import { Form, Field } from "react-final-form";
import axios from "axios";
import PropTypes from 'prop-types';
import { sendFlashMessage } from "@/shared/components/flash";
import { getProgramAction } from "@/redux/actions/programActions";
import getEntrataConnection from '@/service/program/getEntrataConnection';
import AlertPopup from '@/shared/components/modal/alertModal/AlertPopup';
import getUserStatusList from '@/service/getUserStatuses';


const EntrataModal = ({ isOpen, toggle, program, userTypes, dispatch, organization }) => {
    const [loading, setLoading] = useState(true);
    const [userStatusLoading, setUserStatusLoading] = useState(true);
    const [connectionStatus, setConnectionStatus] = useState(null);

    const [entrataSettings, setEntrataSettings] = useState(null);
    const [userStatuses, setUserStatuses] = useState([]);

    const [alertMessage, setAlertMessage] = useState('')
    const [isAlertOpen, setIsAlertOpen] = useState(false)

    useEffect( () => {
        if( organization?.id )
        {
            getEntrataConnection( organization.id, program.id )
            .then( data => {
                setEntrataSettings(data);
                setLoading(false);
            })
        }
    }, []);

    useEffect( () => {
        if( organization?.id )
        {
            getUserStatusList( organization.id )
                .then(list => {
                    setUserStatuses([
                        ...list.map(status => ({ value: status.id, label: status.status }))
                    ]);
                    setUserStatusLoading(false);
                });
        }
    }, [entrataSettings]);

    const onSubmitForm = async (values) => {
        setLoading(true);
        try {
            if(entrataSettings.id){
                const response = await axios.put(`/entrata/${entrataSettings.id}`, values);
                setLoading(false);
                if (response.status === 200) {
                    setEntrataSettings(response.data);
                    dispatch(sendFlashMessage("Entrata configuration has been updated", "alert-success", "top"));
                    dispatch(getProgramAction(organization.id, program.id));
                    toggle(); // Close the modal on success
                }
            }else{
                const response = await axios.put(`/organization/${organization.id}/program/${program.id}/entrata`, values);
                setLoading(false);
                if (response.status === 200){
                    setEntrataSettings(response.data);
                    dispatch(sendFlashMessage("Entrata configuration has been created", "alert-success", "top"));
                    dispatch(getProgramAction(organization.id, program.id));
                    toggle(); // Close the modal on success
                }else{
                    dispatch(sendFlashMessage("Entrata configuration could not be created", "alert-danger", "top"));
                    dispatch(getProgramAction(organization.id, program.id));
                    toggle(); // Close the modal on success
                }
            }

        } catch (error) {
            setLoading(false);
            dispatch(sendFlashMessage(`Entrata configuration could not be updated: ${error.response.data.error}`, "alert-danger", "top"));
            console.error(`API error: ${error.response.data.error}`);
        }
    };

    const verifyConnection = async (values) => {
        if(!entrataSettings.id){
            dispatch(sendFlashMessage("Entrata configuration does not exist", "alert-danger", "top"));
        }else{
            try {
                const response = axios.get(`/entrata/verify/${entrataSettings.id}`)
                  .then( (response) => {
                      console.log(response);

                      var methods = [
                          'customers', 'leads', 'leases', 'reports'
                      ];

                      let messages = [];
                      for (let method of methods) {
                          if(response.data[method].success){
                              messages.push(response.data[method].msg);
                          }else{
                              messages.push(response.data[method].msg);
                          }
                      }
                      setAlertMessage(messages.join('<br/>'));
                      alertToggle();
                  })
                  .catch( error => {
                      console.log(error);
                  })
            } catch (error) {
                setAlertMessage('Verification failed. Please try again.');
                console.log(error)
            }
        }
    };

    const removeConnection = async (values) => {
        if(!entrataSettings.id){
            dispatch(sendFlashMessage("Entrata configuration does not exist", "alert-danger", "top"));
        }else{
            try {
                const response = axios.delete(`/entrata/delete/${entrataSettings.id}`)
                  .then( (response) => {
                      setEntrataSettings({});
                      dispatch(sendFlashMessage("Entrata configuration has been removed", "alert-success", "top"));
                      toggle(); // Close the modal on success
                  })
                  .catch( error => {
                      console.log(error);
                  })
            } catch (error) {
                console.log(error)
            }
        }
    }

    const alertToggle = () => {
        setIsAlertOpen(prevState => !prevState)
    }

    if( loading || userStatusLoading) return 'Loading...'

    return (

        <Modal isOpen={isOpen} toggle={toggle} className="modal-lg">
            <AlertPopup isOpen={isAlertOpen} title="Verify connection" message={alertMessage} toggle={alertToggle} />
            <Form
                onSubmit={onSubmitForm}
                initialValues={entrataSettings}
            >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <ModalHeader toggle={toggle} className='w100' >
                            <Row className='w100'>
                                <Col md="6" lg="6" xl="6" className='text-left'>
                                    Entrata Configurations
                                </Col>
                                <Col md="6" lg="6" xl="6" className='text-right'>
                                  <ButtonToolbar className="modal__footer flex justify-content-right w100">
                                    <Button outline color="secondary" onClick={toggle} className="mr-3">
                                        Close
                                    </Button>
                                    {' '}
                                    <Button
                                        type="submit"
                                        disabled={loading}
                                        color="primary" >
                                        Save Changes
                                    </Button>
                                  </ButtonToolbar>
                                </Col>
                            </Row>
                        </ModalHeader>
                        <ModalBody>
                            <fieldset>
                                <legend>Credentials</legend>
                                <Row>
                                    <Col md="6">
                                        <div className="form-group">
                                            <label htmlFor="url">URL</label>
                                            <Field
                                                name="url"
                                                component="input"
                                                type="text"
                                                className="form-control"
                                                initialValue={entrataSettings.url}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="form-group">
                                            <label htmlFor="entrata_property_id">Entrata Property ID</label>
                                            <Field
                                                name="entrata_property_id"
                                                component="input"
                                                type="text"
                                                className="form-control"
                                                initialValue={entrataSettings.entrata_property_id}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="form-group">
                                            <label htmlFor="user_status_id">User Status</label>
                                            <Field
                                                name="user_status_id"
                                                component="select"
                                                className="form-control"
                                                initialValue={entrataSettings.user_status_id}
                                            >
                                                <option value="">Select Status</option>
                                                {userStatuses.map((status) => (
                                                    <option value={status.value}>
                                                        {status.label}
                                                    </option>
                                                ))}
                                            </Field>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="12">
                                        <div className="form-group w-100 text-start">
                                            <label className="d-flex align-items-center">
                                                <Field
                                                    name="use_leads_api"
                                                    component="input"
                                                    type="checkbox"
                                                    className="me-2"
                                                    initialValue={!!entrataSettings.use_leads_api}
                                                /> &nbsp;
                                                Use GetLeads API
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="12">
                                        <div className="form-group">
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => verifyConnection(values)}
                                                disabled={loading}
                                            >
                                                Verify Connection
                                            </Button>

                                            &nbsp;
                                            <Button
                                                type="button"
                                                color="secondary"
                                                onClick={() => removeConnection(values)}
                                                disabled={loading}
                                            >
                                                Remove Connection
                                            </Button>

                                            {connectionStatus && (
                                                <p className={connectionStatus === "Connection successful" ? "text-success" : "text-danger"}>
                                                    {connectionStatus}
                                                </p>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </fieldset>
                        </ModalBody>
                    </form>
                )}
            </Form>
        </Modal>
    );
};

EntrataModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    program: PropTypes.object.isRequired,
    userTypes: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    organization: PropTypes.object.isRequired,
};

export default withRouter(
    connect((state) => ({
        organization: state.organization,
        userTypes: state.userTypes,
        program: state.program,
    }))(EntrataModal)
);
